import _typeof from "./typeof.js";
import toPrimitive from "./toPrimitive.js";
export default function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
// module id = 393
// module chunks = 0